import { render, staticRenderFns } from "./newsInformation.vue?vue&type=template&id=2fa92505&scoped=true"
import script from "./newsInformation.vue?vue&type=script&lang=js"
export * from "./newsInformation.vue?vue&type=script&lang=js"
import style0 from "./newsInformation.vue?vue&type=style&index=0&id=2fa92505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa92505",
  null
  
)

export default component.exports